<template>
  <div class="pages element-ui-pagination">
    <el-pagination
        background
        layout="prev, pager, next"
        :total=pageData.total
        :page-size=pageData.pageSize
        :current-page=pageData.current
        hide-on-single-page
        @current-change="changeData"
        class="pagess"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
   name: "Pagination",
   props: ['pageData','change'],
   data(){
      return{

      }
  },
  methods:{
    changeData(val){
      this.change(val,this.pageData.pageSize)
    }
  },
  watch: {
    pageData:{
      deep: true,
      handler(val) {
      },
    }
  },
  mounted() {

  }
}
</script>

<style scoped less>
  .pagess{
    margin-top: 30px;
  }
  .pages{
    text-align: center;
  }
</style>
<style>

</style>